<template>
	<div class="images" v-viewer="{ movable: false }" @show="handleAddClick" @hide="handleRemoveKeydown">
		<img
			class="image"
			:key="this.message.id"
			:src="this.message.type === MESSAGE_TYPE.Markdown ? this.message.previewImage : this.message.attachment_url"
			:data-original="this.message.type === MESSAGE_TYPE.Markdown ? this.message.previewImage : this.message.attachment_url"
		/>
	</div>
</template>

<script>
import { getNextPicture, getPervPicture } from "@/services/api-v2/api-v2";
import { MESSAGE_TYPE } from "../chat";

export default {
	name: "ChatImageViewer",

	data() {
		return {
			message: {},
			conversationObjectId: null,
			MESSAGE_TYPE,
		};
	},

	methods: {
		handleAddClick() {
			document.querySelector(".viewer-next").addEventListener("click", this.nextPicture);
			document.querySelector(".viewer-prev").addEventListener("click", this.prevviousPicture);
			document.addEventListener("keydown", this.handleAddKeydown);
		},

		showViewer() {
			const viewer = document.querySelector(".images").$viewer;
			viewer.show();
		},

		imageViewer(message, conversationObjectId) {
			this.message = message;
			this.conversationObjectId = conversationObjectId;
		},

		handleAddKeydown(e) {
			if (e.keyCode === 37) {
				this.prevviousPicture();
			} else if (e.keyCode === 39) {
				this.nextPicture();
			}
		},

		handleRemoveKeydown() {
			document.removeEventListener("keydown", this.handleAddKeydown);
		},

		async nextPicture() {
			try {
				if (this.message.receive_id) {
					const { data, message } = await getNextPicture(this.message.id, this.conversationObjectId, null);
					if (_.has(data, "id")) {
						this.message = data;
					} else {
						this.$message.error(message);
					}
				} else {
					const { data, message } = await getNextPicture(this.message.id, null, this.conversationObjectId);
					if (_.has(data, "id")) {
						this.message = data;
					} else {
						this.$message.error(message);
					}
				}
			} catch (error) {
				this.$message.error(error);
			}
		},

		async prevviousPicture() {
			try {
				if (this.message.receive_id) {
					const { data, message } = await getPervPicture(this.message.id, this.conversationObjectId, null);
					if (_.has(data, "id")) {
						this.message = data;
					} else {
						this.$message.error(message);
					}
				} else {
					const { data, message } = await getPervPicture(this.message.id, null, this.conversationObjectId);
					if (_.has(data, "id")) {
						this.message = data;
					} else {
						this.$message.error(message);
					}
				}
			} catch (error) {
				this.$message.error(error);
			}
		},
	},
};
</script>

<style lang="less" scoped>
.images {
	display: none;
	width: 100px;
	height: 100px;
}
.image {
	display: inherit;
	width: 150px;
	height: 150px;
	max-width: 100%;
	max-height: 100%;
	vertical-align: middle;
	cursor: pointer;
	background-color: #d3d3d3;
}
</style>
<style>
.el-message--error {
	z-index: 3000 !important;
}
</style>
